import { Component } from '@angular/core';
import { HotToastService } from '@ngxpert/hot-toast';
import { CommonService } from '../../../services/common.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-try-now-view',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule, SpinnerComponent, NgxPaginationModule, SearchFilterPipe, RouterOutlet, NgSelectModule, RouterModule],
  templateUrl: './try-now-view.component.html',
  styles: ``
})
export class TryNowViewComponent {
  
  sourceData:any
  outputData:any
  currentData:any

  constructor(
    private readonly toast: HotToastService,
    private readonly commonService: CommonService,
    public formBuilder: FormBuilder,
    private router: Router) {
  }

  ngOnInit(): void {
    this.currentData = history.state;
    this.getTryNowFiles();
  }

  getTryNowFiles() {
    
    forkJoin(
      [
        this.commonService.getFetchTrynow({"migrationName":this.currentData.mig_name,"filePath":this.currentData.folder_name+"Client_Files"}),
        this.commonService.getFetchTrynow({"migrationName":this.currentData.mig_name,"filePath":this.currentData.folder_name+"Conversion"})
      ]
    ).subscribe({
      next: (results: any[]) => {
        this.sourceData = results[0];
        this.outputData = results[1];
      },
      error(err) {
        console.error('Error fetching files:', err);
      },
    });
  }

  updateTryNow(value:string){
    let uobj = {
      foldername: this.currentData.folder_name,
      status: value == "completed" ? "Completed": 'Reviewed'
    }

    let saveObj = {
      fileContent: value,
      migrationName: this.currentData.mig_name,
      filePath: this.currentData.folder_name+"Conversion"
    }

    this.commonService.getUpdateTrynow(uobj).subscribe( (data:any) => {
      if(data['jsonResponseData']['Table1'][0].message == 'Successfully Updated'){
        if(uobj.status == 'Reviewed'){
          this.commonService.getSaveTrynow(saveObj).subscribe( (rs:any) => { console.log(rs)} )
        }
        this.toast.success('Updated Status Successfuly');
      }else{
        this.toast.warning('Something went wrong');
      }
    })
  }

  sendMail(value: any){
    let mailObj = {
      fileContent: value,
      migrationName: this.currentData.mig_name,
      filePath: this.currentData.folder_name+"Conversion",
      type: 'completed',
      email: this.currentData.email
    }

    this.commonService.sendTrynowMail(mailObj).subscribe( (data:any)=>{
      this.updateTryNow("completed")
      this.toast.success(data['status']);
      this.router.navigate(['../tryNow'])
    })
    
  }

}
